import { defineStore } from "pinia";
import {
  getUser,
  loginUser,
  logoutUser,
  getReservations,
  getTransactions,
  getTerms,
  updateDefaultMerchant,
} from "@/repository/api";
import { i18n } from "@/main.js";
export const useUserStore = defineStore("user", {
  state: () => ({
    user: null,
    loggedIn: false,
    isInitialized: false,
    transactions: null,
    reservations: null,
    terms: null,
    terms_old: null,
  }),
  actions: {
    setCredits(credits) {
      this.user.credits = credits;
    },
    async fetchReservations(url = false) {
      const response = await getReservations(url);
      if (response) {
        this.reservations = response?.reservations;
        return response?.reservations;
      }
      return false;
    },
    async fetchTransactions(url = false) {
      const response = await getTransactions(url);
      if (response) {
        this.transactions = response?.transactions;
        return response?.transactions;
      }
      return false;
    },
    async fetchTerms(url = false) {
      const response = await getTerms(url);
      if (response) {
        this.terms = response?.terms;
        this.terms_old = response?.terms_old;
        return response?.terms;
      }
      return false;
    },
    async login(email, password) {
      let { errors } = await loginUser({ email, password });
      if (errors.length === 0) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
        return errors;
      }
      errors = await this.getUser();
      return errors;
    },
    async logout() {
      const result = await logoutUser();
      if (result) {
        this.loggedIn = false;
        this.user = null;
      }
      return false;
    },
    async getUser() {
      const result = await getUser();
      if (result) {
        this.user = result;
        this.loggedIn = true;
        return [];
      } else {
        this.loggedIn = false;
        return [i18n.global.t('api_errors.user_load_failed')];
      }
    },
    async setDefaultMerchant({ merchantId }) {
      const result = await updateDefaultMerchant({ merchantId });
      if (result && this.user) {
        this.user.default_merchant_id = result.default_merchant_id;
      }
      return result;
    },
  },
});
